export const colorList = [
  { name: "黑色", color: "#333333", value: 4 },
  { name: "灰色", color: "#999999", value: 3 },
  { name: "銀色", color: "#e8e8e8", value: 2 },
  { name: "白色", color: "#ffffff", value: 0 },
  { name: "紫色", color: "#5e21d9", value: 11 },
  { name: "棕色", color: "#8c0709", value: 13 },
  { name: "紅色", color: "#ff4333", value: 1 },
  { name: "橙色", color: "#f87f15", value: 8 },
  { name: "黃色", color: "#ffea00", value: 5 },
  { name: "藍色", color: "#013fff", value: 10 },
  { name: "綠色", color: "#00a66e", value: 9 },
  { name: "粉色", color: "#ffb3ad", value: 15 },
  { name: "其他", value: 12 },
];